import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as _ from 'lodash';
import ComboBoxList from '../ComboBoxList/ComboBoxList';
import TextFieldWrapper from '../../components/TextFieldWrapper/TextFieldWrapper';
import cancelEvent from '../../../services/mini/cancelEvent';
import ReactTooltip from 'react-tooltip';
import { Environment } from '../../../const/environment';
const $ = require('jquery');
//todo: move details about tag from this component

type ComboBoxProps = {
    values: any[],
    selectedValueId: string,
    valueKey: string,
    valueName: string,
    environment?: Environment,
    tooltipId?: string,
    tooltipMsg?: string,
    size?: string,
    mode?: string,
    classes?: string,
    noBgStyle?: boolean,
    /** ComboBox width. E.g: "100px" */
    width?: string,
    minWidth?: string,
    maxWidth?: string,
    height?: string,
    disabled?: boolean,
    listMaxHeight?: string,
    listItemCount?: number,
    showListForOneItem?: boolean,
    environmentItem?: boolean,
    withSearch?: boolean,
    noItemsFoundMessage?: string,
    renderItem: (selectedValue: any, inList?: boolean, closeComboBoxCb?: (e) => void) => void,
    onValueSelect: (item: any) => void,
    onMouseLeave?: () => void,
    onClose?: () => void,
    onOpen?: () => void,
    onEdit?: (val: string) => void,
    onDelete?: (val: string) => void,
};

type ComboBoxState = {
    opened: boolean,
    searchQuery: string,
    keyboardSelectedItemId: string | null,
};

class ComboBox extends React.Component<ComboBoxProps, ComboBoxState> {

    _isMounted: boolean;

    constructor(props) {
        super(props);

        this.state = {
            opened: false,
            searchQuery: '',
            keyboardSelectedItemId: props.selectedValueId
        };
    }

    componentDidMount() {
        //todo: refactor
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleClickOutsideCb = (e) => {
        if (!this.state.opened || !this._isMounted) return;
        var domNode = ReactDOM.findDOMNode(this);
        var clickedEl = e.target;

        if ((!domNode || !domNode.contains(clickedEl))) {
            this.closeCompoBox(e);
        }
    }

    componentDidUpdate() {
        const { tooltipId } = this.props;
        if (tooltipId) {
            ReactTooltip.rebuild();
        }
    }

    onKeyCb = (e) => {
        const keyCode = e.keyCode;

        if (keyCode === 27) {
            this.closeCompoBox(e);
        }

        if (keyCode === 40) {
            this.selectItemBelow(e);
        }
        if (keyCode === 38) {
            this.selectItemAbove(e);
        }
        if (keyCode === 13) {
            this.selectItemByEnter(e);
        }
    }

    selectItemByEnter = (e) => {
        const { valueKey } = this.props;
        const { keyboardSelectedItemId } = this.state;
        const values = this.getValues();
        if (values.length === 0) return;
        const item = valueKey ? _.find(values, { [valueKey]: keyboardSelectedItemId }) : keyboardSelectedItemId;

        this.setState({
            searchQuery: ''
        }, () => {
            this.props.onValueSelect(item);
            this.closeCompoBox(e);
        });
    }

    getSelectedIndexItemById = (keyboardSelectedItemId) => {
        const { valueKey } = this.props;
        const values = this.getValues();
        return valueKey ? _.findIndex(values, { [valueKey]: keyboardSelectedItemId }) : values.indexOf(keyboardSelectedItemId);
    }

    getSelectedIdByIndex = (index) => {
        const { valueKey } = this.props;
        const values = this.getValues();
        if (values.length === 0) return null;
        return valueKey ? values[index][valueKey] : values[index];
    }

    selectItemBelow = (e) => {
        const { keyboardSelectedItemId } = this.state;
        const { tooltipId } = this.props;
        const itemsCount = this.getValues().length;
        if (itemsCount === 0) return;
        const selectedItemIndex = this.getSelectedIndexItemById(keyboardSelectedItemId);
        let newId;
        if (selectedItemIndex === -1 || selectedItemIndex === itemsCount - 1) {
            newId = this.getSelectedIdByIndex(0);
        } else {
            newId = this.getSelectedIdByIndex(selectedItemIndex + 1);
        }
        this.setState({ keyboardSelectedItemId: newId });
        this.scrollItemIntoView(newId);
        cancelEvent(e);
        if (tooltipId) {
            ReactTooltip.hide();
        }
    }

    selectItemAbove = (e) => {
        const { tooltipId } = this.props;
        const { keyboardSelectedItemId } = this.state;
        const itemsCount = this.getValues().length;
        if (itemsCount === 0) return;
        const selectedItemIndex = this.getSelectedIndexItemById(keyboardSelectedItemId);
        let newId;
        if (selectedItemIndex === -1 || selectedItemIndex === 0) {
            newId = this.getSelectedIdByIndex(itemsCount - 1);
        } else {
            newId = this.getSelectedIdByIndex(selectedItemIndex - 1);
        }
        this.setState({ keyboardSelectedItemId: newId });
        this.scrollItemIntoView(newId);
        cancelEvent(e);
        if (tooltipId) {
            ReactTooltip.hide();
        }
    }

    scrollItemIntoView = (selectedItemId: string) => {
        if (!this.state.opened || !this._isMounted) return;
        var domNode = ReactDOM.findDOMNode(this);
        var $selectedItem = $(`[data-cb-item-id=${selectedItemId}]`, $(domNode));
        if ($selectedItem[0]) {
            $selectedItem[0].scrollIntoViewIfNeeded();
        }
    }

    getValues = (searchText?: string) => {
        const { values, withSearch, valueName } = this.props;
        const { searchQuery } = this.state;
        return values.filter((value) => {
            const text = valueName ? value[valueName] : value;
            if (withSearch) {
                return text.toLowerCase().indexOf((searchText || searchQuery).toLowerCase()) > -1 ? true : false;
            } else {
                return true;
            }
        });
    }

    toggleState = () => {
        const opened = !this.state.opened;
        const tooltipId = this.props.tooltipId;
        const disabled = this.props.disabled;

        if (disabled) return;

        this.setState({ opened: opened });

        if (opened) {
            document.addEventListener('click', this.handleClickOutsideCb, false);
            document.addEventListener('keydown', this.onKeyCb, false);
            window.addEventListener('codeAreaGotFocus', this.closeCompoBoxByCustomEvent, false);
        }

        if (tooltipId) {
            ReactTooltip.hide();
        }

        if (opened && this.props.onOpen) {
            this.props.onOpen();
        }

        if (!opened && this.props.onClose) {
            this.props.onClose();
        }
        if (tooltipId) {
            ReactTooltip.hide(document.getElementById(tooltipId));
        }
    }

    closeCompoBox = (e) => {
        if (!this._isMounted) return;
        if (this.props.withSearch && this.state.searchQuery) {
            this.setState({ searchQuery: '' });
            cancelEvent(e);
            return;
        }
        if (!this._isMounted) return;
        const { tooltipId } = this.props;
        this.setState({ opened: false, searchQuery: '', keyboardSelectedItemId: null });
        if (tooltipId) {
            ReactTooltip.hide();
        }
        cancelEvent(e);
        if (this.props.onClose) {
            this.props.onClose();
        }
        document.removeEventListener('keydown', this.onKeyCb, false);
        document.removeEventListener('click', this.handleClickOutsideCb, false);
        window.removeEventListener('codeAreaGotFocus', this.closeCompoBoxByCustomEvent, false);
    }

    closeCompoBoxByCustomEvent = (e) => {
        const { tooltipId } = this.props;
        this.setState({ opened: false, searchQuery: '' });

        if (tooltipId) {
            ReactTooltip.hide();
        }

        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    onMouseLeave = (e) => {
        if (this.props.onMouseLeave) {
            this.props.onMouseLeave();
        }
    }

    selectValue = (tag, e) => {
        e.persist();
        this.setState({
            searchQuery: ''
        }, () => {
            this.props.onValueSelect(tag);
            this.closeCompoBox(e);
        });
    }

    onEdit = (val, e) => {
        this.props.onEdit(val);
        this.closeCompoBox(e);
    }

    onDelete = (val, e) => {
        this.props.onDelete(val);
        this.closeCompoBox(e);
    }

    onTextInputChange = (e) => {
        const { keyboardSelectedItemId } = this.state;
        const { valueKey } = this.props;

        const searchQuery = e.target.value;
        const filteredItems = this.getValues(searchQuery);

        const hasSelctedItemInNewList = valueKey ?
            (_.findIndex(filteredItems, { [valueKey]: keyboardSelectedItemId }) !== -1) :
            (filteredItems.indexOf(keyboardSelectedItemId) !== -1);


        this.setState({
            searchQuery,
            keyboardSelectedItemId: hasSelctedItemInNewList ?
                keyboardSelectedItemId :
                (filteredItems.length > 0 ? (this.getSelectedIdByIndex(0)) : null)
        }, () => {
            if (hasSelctedItemInNewList) {
                this.scrollItemIntoView(keyboardSelectedItemId);
            }
        });
    }

    onTextInputBlur = (e) => {
    }

    render() {
        const {
            valueKey,
            valueName,
            selectedValueId,
            renderItem,
            classes,
            tooltipId,
            tooltipMsg,
            mode,
            noBgStyle,
            size,
            width,
            minWidth,
            maxWidth,
            listMaxHeight,
            height,
            showListForOneItem,
            environmentItem,
            withSearch,
            noItemsFoundMessage,
            disabled,
            listItemCount
        } = this.props;
        const { opened, searchQuery, keyboardSelectedItemId } = this.state;
        let { values } = this.props;

        let selectedValue = {};
        let selectedValueText = '';
        let comboBoxClass = `combo-box ${mode} ${size} ${disabled ? 'disabled' : ''}`;
        let disableList = true;

        if (classes) {
            comboBoxClass += ' ' + classes;
        }

        if (withSearch) {
            comboBoxClass += ' with-search';
        }

        if (noBgStyle) {
            comboBoxClass += ' no-bg-style';
        }

        values = this.getValues();

        if (values) {
            for (var i = 0; i < values.length; i++) {
                const isSelected = valueKey ?
                    values[i][valueKey] === selectedValueId :
                    values[i] === selectedValueId;
                if (isSelected) {
                    selectedValue = values[i];
                    break;
                }
            }

            if (values.length > 0) {
                if (values.length > 1 || showListForOneItem) {
                    comboBoxClass += ' has-values';
                    disableList = false;
                }
                selectedValueText = valueName ? selectedValue[valueName] : selectedValue;
            }
        }

        const style = {
            width: width,
            minWidth: minWidth || width,
            maxWidth: maxWidth || width,
        };

        return (
            <div
                className={comboBoxClass}
                onMouseLeave={this.onMouseLeave}
                style={style}>
                <div className={`combo-box_chosen-value ${disableList && 'combo-box_chosen-value_disabled'} ${environmentItem ? 'for-environment' : 'normal'}`}
                    onClick={this.toggleState}
                    ref={tooltipId}
                    data-place="bottom"
                    data-multiline="true"
                    data-effect="solid"
                    data-class="tutor-light-tooltip tutor-no-arrow-tooltip"
                    data-for={tooltipId}
                    data-tip={tooltipMsg}>
                    {renderItem ?
                        renderItem(selectedValue) :
                        <div className="combo-box_value">
                            <span>{selectedValueText}</span>
                        </div>
                    }

                    <div
                        className={`combo-box_arrow oc_tag_list ${disableList && 'disabled'} ${opened && 'opened'}`}>
                        <i className="icon icon-alan-chevron-fat oc_tag_list arrow-icon" />
                    </div>
                    {tooltipId &&
                        <ReactTooltip id={tooltipId} />}
                </div>

                {withSearch && <div className={`combo-box_search ${opened && 'opened'}`}>
                    <TextFieldWrapper
                        placeholder="Search"
                        name="query"
                        id="query"
                        value={searchQuery}
                        type="text"
                        autoComplete="off"
                        skipOnChangeAfterOnBlur={true}
                        onChange={this.onTextInputChange}
                        onEsc={(e) => {
                            if (this.props.withSearch && this.state.searchQuery) {
                                this.setState({ searchQuery: '' });
                                cancelEvent(e);
                                return;
                            }
                        }}
                        onBlur={this.onTextInputBlur} />
                </div>}

                {opened && <ComboBoxList
                    opened={opened}
                    values={values}
                    valueKey={valueKey}
                    valueName={valueName}
                    listMaxHeight={listMaxHeight}
                    listItemCount={listItemCount}
                    height={height}
                    withSearch={withSearch}
                    selectValue={this.selectValue}
                    selectedValueText={selectedValueText}
                    renderItem={renderItem}
                    keyboardSelectedItemId={keyboardSelectedItemId}
                    closeCompoBoxCb={this.closeCompoBox}
                    noItemsFoundMessage={(withSearch && values.length === 0) ? (noItemsFoundMessage || 'No items found') : null}
                />}
            </div>
        );
    }
}

export default ComboBox;